import type { ReactElement } from "react";

import { useTT } from "../useTT";
import { ErrorNumbers } from "./ErrorNumbers";
import { ErrorPageContent } from "./ErrorPageContent";

export function Error401Content(): ReactElement {
  const { tt } = useTT();

  return (
    <ErrorPageContent
      graphic={<ErrorNumbers>401</ErrorNumbers>}
      title={tt("errorPages.Error401.title")}
      description={tt("errorPages.Error401.description")}
      buttonTitle={tt("errorPages.Error401.buttonTitle")}
      onButtonClick={() => (window.location.href = "/")}
    />
  );
}
